import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "Como funciona um projeto típico com a Ponzena?",
    a: "Começamos com um diagnóstico curto (2 a 4 semanas) para mapear processos, sistemas e gargalos. Em seguida, montamos um roadmap com quick wins e evoluções estruturais. Trabalhamos em squads enxutos com entregas incrementais e sempre com KPIs de sucesso definidos no início.",
  },
  {
    q: "Vocês atuam apenas com Totvs Protheus?",
    a: "Não. Protheus é uma das nossas maiores especialidades, mas atuamos também com Oracle EBS/Cloud, SAP B1, Totvs Logix, Totvs RM e Datasul — incluindo integrações e migrações entre eles.",
  },
  {
    q: "Como funciona a preparação para a Reforma Tributária?",
    a: "Trabalhamos em quatro frentes: (1) diagnóstico de impacto por operação e produto, (2) adequação de layouts e regras fiscais no ERP, (3) simulações de crédito CBS/IBS e (4) capacitação do time fiscal. O objetivo é chegar em 2026/2033 com o ERP e o processo prontos, sem susto.",
  },
  {
    q: "O que é 'vibe coding' e 'low-code' na prática?",
    a: "É dar ao time de backoffice ferramentas seguras (PowerApps, Power Automate, UiPath, Python assistido por IA) para construir e evoluir suas próprias automações — com governança, versionamento e compliance. O ganho é enorme em velocidade e engajamento.",
  },
  {
    q: "Precisamos ter um time de TI grande para começar?",
    a: "Não. A proposta é justamente dar autonomia ao próprio time de negócio (fiscal, financeiro, PCP, logística) para operar as ferramentas modernas. A TI atua como guardiã da arquitetura e da segurança.",
  },
  {
    q: "Como é a cobrança e os formatos de contrato?",
    a: "Trabalhamos em três formatos: projeto fechado (com escopo definido), squad mensal (para evolução contínua) e workshops/trilha de capacitação por turma. Podemos combinar formatos conforme a necessidade.",
  },
];

export default function FAQ() {
  return (
    <section id="faq" className="relative py-28 md:py-36" data-testid="faq-section">
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        <div className="text-center mb-14">
          <p className="label-eyebrow">Perguntas frequentes</p>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl mt-4 leading-tight tracking-tight text-white">
            Tire suas <span className="gradient-text">dúvidas</span>.
          </h2>
        </div>

        <Accordion type="single" collapsible className="w-full space-y-3" data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="card-surface px-6 py-1 border-none"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="text-left font-display text-lg md:text-xl font-semibold text-white hover:text-cyan-400 hover:no-underline py-6">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-[#B8C0D0] leading-relaxed pb-6 text-base">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
